import { AbstractControl } from "@angular/forms";

export default class Tools {
  static formatarTelefone(telefone: string): string {
    const regex = /(\d{2})(\d{4,5})(\d{4})/;

    return telefone.replace(regex, '($1) $2-$3');
  }

  static formatarCnpj(cnpj: string): string {
    return cnpj.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5'
    );
  }

  static formatarCep(cep: string): string {
    return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
  }

  static formatarData(data: string): string {
    const dataObj = new Date(data);
    const ano = dataObj.getFullYear().toString().padStart(4, '0');
    const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0'); // O mês é baseado em zero
    const dia = dataObj.getDate().toString().padStart(2, '0');
    const hora = dataObj.getHours().toString().padStart(2, '0');
    const minuto = dataObj.getMinutes().toString().padStart(2, '0');
    const segundo = dataObj.getSeconds().toString().padStart(2, '0');

    return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
  }

  static removeNaoNumeros(input: string): string {
    return input.replace(/\D/g, '');
  }
}